/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EmptySuccessfulResponse } from '../models/empty-successful-response';
import { ListApiResponse } from '../models/list-api-response';
import { SurchargeListItemResponse } from '../models/surcharge-list-item-response';
import { SurchargeUpdateRequest } from '../models/surcharge-update-request';

@Injectable({
  providedIn: 'root',
})
export class CustomerLocationSurchargeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCustomerSurchargeList
   */
  static readonly GetCustomerSurchargeListPath = '/api/web/v1/customers/{customer}/locations/{location}/surcharges';

  /**
   * Get surcharges list.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerSurchargeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerSurchargeList$Response(params: {
    customer: number;
    location: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerLocationSurchargeService.GetCustomerSurchargeListPath, 'get');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('location', params.location, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListApiResponse & {
        'data'?: Array<SurchargeListItemResponse>;
        }>;
      })
    );
  }

  /**
   * Get surcharges list.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerSurchargeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerSurchargeList(params: {
    customer: number;
    location: number;
    context?: HttpContext
  }
): Observable<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}> {

    return this.getCustomerSurchargeList$Response(params).pipe(
      map((r: StrictHttpResponse<ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
}>) => r.body as ListApiResponse & {
'data'?: Array<SurchargeListItemResponse>;
})
    );
  }

  /**
   * Path part for operation putCustomerSurchargeUpdate
   */
  static readonly PutCustomerSurchargeUpdatePath = '/api/web/v1/customers/{customer}/locations/{location}/surcharges/{surcharge}';

  /**
   * Update a surcharge.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putCustomerSurchargeUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerSurchargeUpdate$Response(params: {
    customer: number;
    location: number;
    surcharge: number;
    context?: HttpContext
    body: SurchargeUpdateRequest
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerLocationSurchargeService.PutCustomerSurchargeUpdatePath, 'put');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('location', params.location, {});
      rb.path('surcharge', params.surcharge, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Update a surcharge.
   *
   * **Accessible only for users with roles 'ROLE_CUSTOMER_ADMIN', 'ROLE_CUSTOMER_LOCATION_ADMIN'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putCustomerSurchargeUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerSurchargeUpdate(params: {
    customer: number;
    location: number;
    surcharge: number;
    context?: HttpContext
    body: SurchargeUpdateRequest
  }
): Observable<EmptySuccessfulResponse> {

    return this.putCustomerSurchargeUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

}
